import { render, staticRenderFns } from "./EdenCrmSidebar.vue?vue&type=template&id=4856318a&scoped=true"
import script from "./EdenCrmSidebar.vue?vue&type=script&lang=js"
export * from "./EdenCrmSidebar.vue?vue&type=script&lang=js"
import style0 from "./EdenCrmSidebar.vue?vue&type=style&index=0&id=4856318a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856318a",
  null
  
)

export default component.exports